(function () {
  'use strict';

  const TARGET_MULTIPLIER = 1.1;   // riempi al 110% del container
  const MAX_DUPLICATION   = 50;    // safety cap
  const SPEED_MULTIPLIER  = 10;    // come l'originale: speed × 10 = px/s

  function fillTrack(track, itemSelector, targetSize) {
    // Prendi solo gli item "originali" (non i cloni con aria-hidden)
    const items = Array.from(track.querySelectorAll(itemSelector))
      .filter(el => el.getAttribute('aria-hidden') !== 'true');
    if (!items.length) return;

    // Reset: rimuovi eventuali cloni precedenti (utile su resize)
    track.innerHTML = '';
    items.forEach(item => track.appendChild(item.cloneNode(true)));

    let rounds = 0;
    while (track.scrollWidth < targetSize && rounds < MAX_DUPLICATION) {
      items.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      rounds++;
    }
  }

  function syncSecondTrack(firstTrack, secondTrack) {
    secondTrack.innerHTML = '';
    Array.from(firstTrack.children).forEach(child => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      secondTrack.appendChild(clone);
    });
  }

  function applyDuration(container, tracks) {
    const speed = parseFloat(container.dataset.marqueeSpeed) || 12;
    const totalWidth = Array.from(tracks)
      .reduce((sum, t) => sum + t.scrollWidth, 0);
    const duration = totalWidth / (speed * SPEED_MULTIPLIER);
    tracks.forEach(t => t.style.animationDuration = `${duration}s`);
  }

  function initMarquee(container) {
    const tracks = container.querySelectorAll('.pbmarquee_track');
    if (!tracks.length) return;

    const itemSelector = container.dataset.trackItemSelector
      || '.pbmarquee__text-wrapper';

    const containerWidth = container.getBoundingClientRect().width;
    const targetSize = containerWidth * TARGET_MULTIPLIER;

    fillTrack(tracks[0], itemSelector, targetSize);
    if (tracks[1]) syncSecondTrack(tracks[0], tracks[1]);
    applyDuration(container, tracks);
  }

  function initAll() {
    document.querySelectorAll('[data-pb-marquee]').forEach(initMarquee);
  }

  // Init iniziale
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Resize debounced
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  // Re-init nel theme editor di Shopify
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();